<!-- ── Member List Card ─────────────────────────────────────────────────────── -->
<div class="card bb-fill-card">
  <div class="card-header d-flex align-items-center justify-content-between flex-wrap gap-2">
    <div class="d-flex align-items-center gap-2">
      <span class="fw-semibold"><i class="pe-7s-users me-2 text-primary"></i>Members List</span>
      <span class="badge bg-primary-subtle text-primary-emphasis" *ngIf="isManager && selectedCenter">
        <i class="pe-7s-home me-1"></i>{{ selectedCenter.centerName }} — {{ selectedCenter.area }}
      </span>
    </div>
    <div class="d-flex align-items-center gap-2">
      <span class="badge bg-secondary">{{ records.length }} records</span>
      <button type="button" class="btn btn-outline-secondary btn-sm" (click)="loadData()" title="Refresh"
              [disabled]="isLoading">
        <i class="pe-7s-refresh-2" [class.spin]="isLoading"></i>
      </button>
      <button type="button" class="btn btn-outline-warning btn-sm" *ngIf="isAdmin || isManager"
              (click)="doRefreshMembershipStatus()" [disabled]="isRefreshing" title="Check all active members and move expired ones to Due status">
        <span *ngIf="!isRefreshing"><i class="pe-7s-refresh me-1"></i> Refresh Status</span>
        <span *ngIf="isRefreshing" class="d-flex align-items-center gap-1">
          <span class="spinner-border spinner-border-sm"></span> Refreshing...
        </span>
      </button>
      <button type="button" class="btn btn-primary btn-sm" *ngIf="showAddButton" (click)="addRequested.emit()">
        <i class="pe-7s-plus me-1"></i> Add New Member
      </button>
    </div>
  </div>
  <div *ngIf="refreshMsg || refreshError"
       class="px-3 py-1 d-flex align-items-center gap-2 border-bottom"
       [class.bg-success-subtle]="refreshMsg && !refreshError"
       [class.bg-danger-subtle]="refreshError">
    <span *ngIf="refreshMsg" class="small text-success-emphasis">
      <i class="pe-7s-check me-1"></i>{{ refreshMsg }}
    </span>
    <span *ngIf="refreshError" class="small text-danger">
      <i class="pe-7s-close-circle me-1"></i>{{ refreshError }}
    </span>
    <button type="button" class="btn-close btn-close-sm ms-auto" style="font-size:.65rem;"
            (click)="refreshMsg=''; refreshError=''"></button>
  </div>
  <div class="card-body p-0 bb-fill-body">
    <div class="text-center py-5" *ngIf="isLoading">
      <div class="spinner-border text-primary"></div>
      <p class="mt-2 text-muted">Loading members...</p>
    </div>
    <vio-table-v2 *ngIf="!isLoading" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
  </div>
</div>

<!-- ── Membership Management Modal ───────────────────────────────────────────── -->
<div *ngIf="showMembership"
     class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
     style="background:rgba(0,0,0,.5);z-index:1055;"
     (click)="closeMembershipManagement()">
  <div class="card shadow-lg mmp-card" (click)="$event.stopPropagation()">

    <div class="card-header d-flex align-items-center justify-content-between py-2 px-3">
      <div class="d-flex align-items-center gap-2 min-w-0">
        <i class="pe-7s-id text-primary flex-shrink-0"></i>
        <span class="fw-bold text-nowrap">Membership Management</span>
        <div class="mmp-header-member ms-2" *ngIf="membershipRecord">
          <span class="mmp-header-member-name">{{ membershipRecord.name }}</span>
          <span class="mmp-header-member-since" *ngIf="membershipRecord.memberSince">
            Member since: {{ membershipRecord.memberSince | appDate }}
          </span>
        </div>
      </div>
      <button class="btn-close flex-shrink-0 ms-2" (click)="closeMembershipManagement()"></button>
    </div>

    <div class="card-body px-3 py-2">

      <div class="mmp-info">
        <div class="mmp-topline">
          <div class="mmp-topline-no">
            <span class="mmp-label">Member No.</span>
            <span class="mmp-val fw-bold">{{ membershipRecord?.memNo || '—' }}</span>
          </div>
          <div class="mmp-topline-sep"></div>
          <div class="mmp-topline-expiry">
            <span class="mmp-label">{{ isMembershipExpired() ? 'Membership Expired On' : 'Membership Expiring On' }}</span>
            <span class="mmp-val" [class.text-danger]="isMembershipExpired()">
              {{ membershipRecord?.membershipExpiresOn ? (membershipRecord.membershipExpiresOn | appDate) : '—' }}
            </span>
          </div>
          <div class="mmp-topline-sep"></div>
          <div class="mmp-topline-status">
            <span class="mmp-label">Status</span>
            <span class="badge" [ngClass]="getMemberDisplayStatus(membershipRecord).cls">
              {{ getMemberDisplayStatus(membershipRecord).label }}
            </span>
          </div>
        </div>
      </div>

      <div class="mmp-divider"></div>

      <!-- ── Confirmation summary ──────────────────────────────────────────────── -->
      <ng-container *ngIf="showRenewalConfirm">
        <div class="mmp-confirm-box">
          <div class="mmp-confirm-icon"><i class="pe-7s-info text-primary"></i></div>
          <p class="mmp-confirm-title">Confirm Renewal</p>
          <div class="mmp-confirm-row">
            <span class="mmp-label">Member Name</span>
            <span class="mmp-val">{{ membershipRecord?.name }}</span>
          </div>
          <div class="mmp-confirm-row">
            <span class="mmp-label">Renewal Period</span>
            <span class="mmp-val">{{ confirmPeriodLabel }}</span>
          </div>
          <div class="mmp-confirm-row">
            <span class="mmp-label">New Membership Expiry Date</span>
            <span class="mmp-val text-success fw-bold fs-6">{{ confirmNewExpiryLabel }}</span>
          </div>
        </div>
      </ng-container>

      <!-- ── Normal mode ───────────────────────────────────────────────────── -->
      <ng-container *ngIf="!showRenewalConfirm">

      <!-- Horizontal tab row -->
      <div class="mmp-htabs" *ngIf="!membershipSuccessMsg">
        <button *ngIf="mmpShowSection('renew')" type="button"
                class="mmp-htab mmp-htab--renew" [class.mmp-htab--active]="activeMmpSection === 'renew'"
                (click)="toggleMmpSection('renew')">
          <i class="pe-7s-refresh"></i> Renew / Extend
        </button>

        <button *ngIf="mmpShowSection('hold')" type="button"
                class="mmp-htab mmp-htab--hold" [class.mmp-htab--active]="activeMmpSection === 'hold'"
                (click)="toggleMmpSection('hold')">
          <i class="pe-7s-clock"></i> Put On Hold
        </button>
        <button *ngIf="mmpShowSection('close')" type="button"
                class="mmp-htab mmp-htab--close" [class.mmp-htab--active]="activeMmpSection === 'close'"
                (click)="toggleMmpSection('close')">
          <i class="pe-7s-lock"></i> Close
        </button>
      </div>

      <!-- Single content panel -->
      <div class="mmp-hcontent" *ngIf="activeMmpSection && !membershipSuccessMsg">

        <!-- === Renew / Extend === -->
        <ng-container *ngIf="activeMmpSection === 'renew'">
          <div class="text-center py-3" *ngIf="isLoadingPlans">
            <div class="spinner-border spinner-border-sm text-primary"></div>
            <span class="ms-2 text-muted small">Loading plans…</span>
          </div>
          <div *ngIf="!isLoadingPlans">
            <div class="mmp-start-section">
              <span class="mmp-label d-block">Start Renewal From</span>
              <div class="mmp-start-group">
                <label class="mmp-start-opt" [class.mmp-start-opt--active]="renewStartOption === 'expiry'"
                       [class.mmp-start-opt--disabled]="!hasExpiryDate">
                  <input type="radio" name="renewStart" value="expiry" [(ngModel)]="renewStartOption" [disabled]="!hasExpiryDate">
                  <span class="mmp-start-opt-label">Last Expiry</span>
                  <span class="mmp-start-opt-date">{{ hasExpiryDate ? (membershipRecord.membershipExpiresOn | appDate) : 'No expiry set' }}</span>
                </label>
                <label class="mmp-start-opt" [class.mmp-start-opt--active]="renewStartOption === 'today'">
                  <input type="radio" name="renewStart" value="today" [(ngModel)]="renewStartOption">
                  <span class="mmp-start-opt-label">From Today</span>
                  <span class="mmp-start-opt-date">{{ todayString() | appDate }}</span>
                </label>
                <label class="mmp-start-opt mmp-start-opt--custom" [class.mmp-start-opt--active]="renewStartOption === 'custom'"
                       (click)="openCustomDatePicker()">
                  <input type="radio" name="renewStart" value="custom" [(ngModel)]="renewStartOption">
                  <span class="mmp-start-opt-label">Custom Date</span>
                  <span class="mmp-start-opt-date">{{ renewStartOption === 'custom' && renewCustomDate ? (renewCustomDate | appDate) : 'Pick a date' }}</span>
                </label>
              </div>
              <input #customDateInput type="date" class="mmp-hidden-date-input" [(ngModel)]="renewCustomDate" />
            </div>
            <div class="mmp-renew-row mt-2">
              <div class="mmp-renew-period">
                <label class="mmp-label mb-1">Renewal Period</label>
                <select class="form-select form-select-sm" [(ngModel)]="membershipMonths" (ngModelChange)="onPlanSelected()">
                  <option *ngFor="let p of subscriptionPlans" [ngValue]="p.months">{{ p.label || p.months + ' Month(s)' }}</option>
                  <option *ngIf="subscriptionPlans.length === 0" [ngValue]="membershipMonths" disabled>No plans available</option>
                </select>
              </div>
              <div class="mmp-renew-period">
                <label class="mmp-label mb-1">Amount (₹)</label>
                <div class="input-group input-group-sm">
                  <span class="input-group-text">₹</span>
                  <input type="text" class="form-control form-control-sm bg-light" [value]="membershipAmount ?? '—'" readonly />
                </div>
              </div>
              <div class="mmp-renew-expiry">
                <span class="mmp-label">New Expiry Date</span>
                <span class="mmp-val text-success fw-bold">{{ getNewExpiryDate() | appDate }}</span>
              </div>
            </div>
            <hr class="my-2">
            <div class="row g-2">
              <div class="col-6">
                <label class="mmp-label mb-1 d-block">Mode of Payment</label>
                <select class="form-select form-select-sm" [(ngModel)]="renewPaymentMode">
                  <option *ngFor="let m of paymentModes" [value]="m">{{ m }}</option>
                </select>
              </div>
              <div class="col-6">
                <label class="mmp-label mb-1 d-block">Trnx / Reference ID</label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="renewPaymentTrnxRef" placeholder="UPI ref / Chq no / etc." />
              </div>
              <div class="col-12">
                <label class="mmp-label mb-1 d-block">Remarks</label>
                <input type="text" class="form-control form-control-sm" [(ngModel)]="renewPaymentRemarks" placeholder="Optional" />
              </div>
            </div>
          </div>
        </ng-container>


        <!-- === Put On Hold === -->
        <ng-container *ngIf="activeMmpSection === 'hold'">
          <div class="mb-3">
            <label class="mmp-label mb-1 d-block">On Hold Till <span class="text-danger">*</span></label>
            <input type="date" class="form-control form-control-sm" [(ngModel)]="mmpHoldTill"
                   [min]="todayString()" style="max-width:200px;" />
            <div class="form-text small">Membership will be inactive until this date.</div>
          </div>
          <div class="d-flex justify-content-end">
            <button class="btn btn-warning btn-sm" (click)="confirmOnHold()" [disabled]="membershipSaving || !mmpHoldTill">
              <span *ngIf="membershipSaving" class="spinner-border spinner-border-sm me-1"></span>
              <i *ngIf="!membershipSaving" class="pe-7s-clock me-1"></i>Confirm Hold
            </button>
          </div>
        </ng-container>

        <!-- === Close Membership === -->
        <ng-container *ngIf="activeMmpSection === 'close'">

          <!-- Block closure if member has unreturned books -->
          <div *ngIf="membershipRecord?.borrowedBooks?.length > 0"
               class="alert alert-danger d-flex align-items-start gap-2 py-2 px-3 mb-2" style="font-size:.82rem;">
            <i class="pe-7s-attention mt-1 flex-shrink-0" style="font-size:1.1rem;"></i>
            <div>
              <strong>Cannot close membership.</strong>
              Member has <strong>{{ membershipRecord.borrowedBooks.length }}</strong>
              book{{ membershipRecord.borrowedBooks.length === 1 ? '' : 's' }} pending return.
              Please receive all books before closing the membership.
            </div>
          </div>

          <ng-container *ngIf="!(membershipRecord?.borrowedBooks?.length > 0)">
          <div class="mb-2">
            <label class="mmp-label mb-1 d-block">
              Reason for Closure <span *ngIf="closureReasons.length" class="text-danger">*</span>
            </label>
            <div class="input-group input-group-sm">
              <select class="form-select form-select-sm" [(ngModel)]="mmpCloseReasonId"
                      [disabled]="closureReasonsLoading || !closureReasons.length">
                <option value="">{{ closureReasonsLoading ? 'Loading reasons…' : (closureReasons.length ? '— Select reason —' : 'No reasons yet — click + to add') }}</option>
                <option *ngFor="let r of closureReasons" [value]="r._id">{{ r.reasonName }}</option>
              </select>
              <button type="button" class="btn btn-outline-primary" title="Add a new reason"
                      (click)="openAddReason()" [disabled]="showAddReason">
                <i class="pe-7s-plus"></i>
              </button>
            </div>
            <!-- Inline add-reason popup -->
            <div *ngIf="showAddReason" class="border rounded p-2 mt-1 bg-light">
              <div class="input-group input-group-sm">
                <input type="text" class="form-control" placeholder="New reason, e.g. Relocated" maxlength="100"
                       [(ngModel)]="newReasonName" (keyup.enter)="saveNewReason()" (keyup.escape)="cancelAddReason()"
                       [disabled]="addReasonSaving" autofocus />
                <button type="button" class="btn btn-primary" (click)="saveNewReason()" [disabled]="addReasonSaving">
                  <span *ngIf="addReasonSaving" class="spinner-border spinner-border-sm"></span>
                  <span *ngIf="!addReasonSaving">Add</span>
                </button>
                <button type="button" class="btn btn-outline-secondary" (click)="cancelAddReason()" [disabled]="addReasonSaving">Cancel</button>
              </div>
              <div *ngIf="addReasonError" class="text-danger mt-1" style="font-size:.72rem;">{{ addReasonError }}</div>
            </div>
          </div>
          <p class="mmp-label text-uppercase mb-2" style="font-size:.65rem;letter-spacing:.6px;">Deposit Refund Details</p>
          <div class="row g-2">
            <!-- Refund mode — full width -->
            <div class="col-12">
              <label class="mmp-label mb-1 d-block">Refund Mode</label>
              <div class="d-flex gap-2 flex-wrap">
                <div *ngFor="let m of paymentModes">
                  <input type="radio" class="btn-check" [id]="'mmp_rfm_' + m" [value]="m"
                         [(ngModel)]="mmpCloseRefundMode" name="mmpCloseRefundMode" />
                  <label class="btn btn-sm btn-outline-secondary" [for]="'mmp_rfm_' + m">{{ m }}</label>
                </div>
              </div>
            </div>
            <!-- Row: Trnx ID | Amount | Date -->
            <div class="col-5">
              <label class="mmp-label mb-1 d-block">Trnx ID / Reference</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="mmpCloseRefundTrnxId" placeholder="UPI ref / Chq no etc." />
            </div>
            <div class="col-3">
              <label class="mmp-label mb-1 d-block">Amount (₹)</label>
              <div class="input-group input-group-sm">
                <span class="input-group-text">₹</span>
                <input type="number" class="form-control" [(ngModel)]="mmpCloseRefundAmount"
                       [placeholder]="membershipRecord?.depositAmount || '0'" />
              </div>
            </div>
            <div class="col-4">
              <label class="mmp-label mb-1 d-block">Date of Refund</label>
              <input type="date" class="form-control form-control-sm" [(ngModel)]="mmpCloseRefundDate" />
            </div>
            <!-- Row: Returned To | Phone | Remarks -->
            <div class="col-4">
              <label class="mmp-label mb-1 d-block">Returned To</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="mmpCloseReturnedTo" placeholder="Recipient name" />
            </div>
            <div class="col-4">
              <label class="mmp-label mb-1 d-block">Phone No.</label>
              <input type="tel" class="form-control form-control-sm" [(ngModel)]="mmpCloseReturnedToPhone" placeholder="Phone number" maxlength="10" />
            </div>
            <div class="col-4">
              <label class="mmp-label mb-1 d-block">Remarks</label>
              <input type="text" class="form-control form-control-sm" [(ngModel)]="mmpCloseRemarks" placeholder="Optional" />
            </div>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <button class="btn btn-danger btn-sm" (click)="confirmClose()" [disabled]="membershipSaving">
              <span *ngIf="membershipSaving" class="spinner-border spinner-border-sm me-1"></span>
              <i *ngIf="!membershipSaving" class="pe-7s-lock me-1"></i>Confirm &amp; Close Membership
            </button>
          </div>
          </ng-container><!-- end no-borrowed-books guard -->
        </ng-container>

      </div><!-- end mmp-hcontent -->

      <!-- Success state -->
      <div *ngIf="membershipSuccessMsg" class="mmp-success-banner">
        <i class="pe-7s-check-circle mmp-success-icon"></i>
        <div class="mmp-success-text">{{ membershipSuccessMsg }}</div>
      </div>

      </ng-container><!-- end !showRenewalConfirm -->

    </div>

    <div class="card-footer py-2 px-3">
      <div *ngIf="membershipErrorMsg" class="text-danger small mb-2">
        <i class="pe-7s-close-circle me-1"></i>{{ membershipErrorMsg }}
      </div>

      <!-- Footer: confirmation mode -->
      <div *ngIf="showRenewalConfirm" class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary btn-sm" (click)="cancelRenewalConfirm()">Back</button>
        <button type="button" class="btn btn-success btn-sm" (click)="confirmRenewal()" [disabled]="membershipSaving">
          <span *ngIf="!membershipSaving"><i class="pe-7s-check me-1"></i>Go Ahead</span>
          <span *ngIf="membershipSaving" class="d-flex align-items-center gap-1">
            <span class="spinner-border spinner-border-sm"></span> Saving…
          </span>
        </button>
      </div>

      <!-- Footer: normal mode -->
      <div *ngIf="!showRenewalConfirm" class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary btn-sm" (click)="closeMembershipManagement()">Close</button>
        <button *ngIf="activeMmpSection === 'renew' && !membershipSuccessMsg" type="button"
                class="btn btn-primary btn-sm" (click)="previewRenewal()">
          <i class="pe-7s-refresh me-1"></i>Renew Membership
        </button>
      </div>
    </div>

  </div>
</div>

<!-- ── Transaction Report Modal ───────────────────────────────────────────────── -->
<app-book-exchange
  *ngIf="showTransactionReport"
  [asModal]="true"
  [preselectedMember]="transactionReportMember"
  (closed)="closeTransactionReport()">
</app-book-exchange>

<!-- ── Member History Modal ────────────────────────────────────────────────────── -->
<div *ngIf="showHistory"
     class="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
     style="background:rgba(0,0,0,.5);z-index:1055;"
     (click)="closeHistory()">
  <div class="card shadow-lg"
       style="width:860px;max-width:95vw;max-height:85vh;display:flex;flex-direction:column;overflow:hidden;"
       (click)="$event.stopPropagation()">
    <div class="card-header d-flex align-items-center justify-content-between py-3">
      <div>
        <i class="pe-7s-clock me-2 text-info"></i>
        <span class="fw-bold">Book Borrowing History</span>
        <span class="text-muted ms-2 small">{{ historyTitle }}</span>
      </div>
      <button class="btn-close" (click)="closeHistory()"></button>
    </div>
    <div class="card-body p-0 overflow-auto">
      <div *ngIf="historyMember?.status === 'Closed'"
           class="alert alert-danger rounded-0 border-0 border-bottom d-flex align-items-start gap-2 py-2 px-3 mb-0 small">
        <i class="pe-7s-lock mt-1 flex-shrink-0"></i>
        <div>
          <strong>Membership closed</strong>
          <span *ngIf="historyMember.closedAt || historyMember.closureDetails?.closedAt">
            on {{ (historyMember.closedAt || historyMember.closureDetails?.closedAt) | appDate }}</span>
          <div>Reason: <strong>{{ historyMember.closureDetails?.closureReason || 'Not recorded' }}</strong></div>
          <div *ngIf="historyMember.closureDetails?.refundRemarks">Remarks: {{ historyMember.closureDetails.refundRemarks }}</div>
        </div>
      </div>
      <div class="text-center py-5" *ngIf="historyLoading">
        <div class="spinner-border text-info"></div>
        <p class="mt-2 text-muted small">Loading history…</p>
      </div>
      <div class="text-center py-5 text-muted" *ngIf="!historyLoading && historyData.length === 0">
        <i class="pe-7s-bookmarks" style="font-size:2.5rem;opacity:.4"></i>
        <p class="mt-2 small">No borrowing history found.</p>
      </div>
      <table class="table table-hover table-bordered mb-0" *ngIf="!historyLoading && historyData.length > 0">
        <thead class="table-light sticky-top">
          <tr>
            <th>#</th><th>Book Name</th><th>Serial No.</th>
            <th>Issue Date</th><th>Return Date</th><th class="text-center">Days</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of historyData; let i = index" [class.table-warning]="!row.receivedOn">
            <td>{{ i + 1 }}</td>
            <td>{{ row.bookName }}</td>
            <td><code>{{ row.bookSrNo || '—' }}</code></td>
            <td>{{ row.issuedOn ? (row.issuedOn | appDate) : '—' }}</td>
            <td>
              <span *ngIf="row.receivedOn">{{ row.receivedOn | appDate }}</span>
              <span *ngIf="!row.receivedOn" class="badge bg-warning text-dark">With Member</span>
            </td>
            <td class="text-center">
              <span *ngIf="row.daysWithMember !== null" class="badge"
                    [class.bg-success]="row.daysWithMember <= 30"
                    [class.bg-warning]="row.daysWithMember > 30 && row.daysWithMember <= 60"
                    [class.bg-danger]="row.daysWithMember > 60">{{ row.daysWithMember }}</span>
              <span *ngIf="row.daysWithMember === null" class="text-muted">—</span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center py-2 text-muted small border-top"
           *ngIf="!historyLoading && historyData.length > 0">
        {{ historyData.length }} record{{ historyData.length === 1 ? '' : 's' }}
      </div>
    </div>
  </div>
</div>
